import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Button,
    Typography,
    Divider,
    Grid,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ServiceAndBalanceAgreement({
    open,
    onClose,
    markaUnvan = "",
    markaMersisVno = "",
    markaAdres = "",
    markaTemsilciAdSoyad = "",
    markaEposta = "",
    markaTel = "",
    paketAdi = "",
    bakiyeTutari = "",
    urunHizmetAdi = "",
    kullaniciOdemeTutari = "",
    markaIban = "",
}) {
    const Section = ({ title, children, id }) => (
        <Box id={id} sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
                {title}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box>{children}</Box>
        </Box>
    );

    const InfoRow = ({ label, value }) => (
        <Grid container spacing={1} sx={{ mb: 0.5 }}>
            <Grid item xs={4} sm={3} md={2}>
                <Typography variant="body2" color="text.secondary">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={8} sm={9} md={10}>
                <Typography variant="body2">{value}</Typography>
            </Grid>
        </Grid>
    );

    const PaketsTableRetail = (
        <Table size="small" sx={{ mt: 1 }}>
            <TableHead>
                <TableRow>
                    <TableCell>Paket</TableCell>
                    <TableCell>Bakiye</TableCell>
                    <TableCell>Hediye Medya</TableCell>
                    <TableCell>Görünürlük</TableCell>
                    <TableCell>Influencer / UGC</TableCell>
                    <TableCell>Raporlama</TableCell>
                    <TableCell>Komisyon</TableCell>
                    <TableCell>GMV Tavanı</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell>Başlangıç Modeli</TableCell>
                    <TableCell>–</TableCell>
                    <TableCell>–</TableCell>
                    <TableCell>–</TableCell>
                    <TableCell>–</TableCell>
                    <TableCell>Temel raporlama</TableCell>
                    <TableCell>%12 satış komisyonu</TableCell>
                    <TableCell>Sınırsız</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Başlangıç Paketi</TableCell>
                    <TableCell>50.000 TL</TableCell>
                    <TableCell>1 Hafta Yovi Metro (12M erişim)</TableCell>
                    <TableCell>7 gün ana sayfa + kategori</TableCell>
                    <TableCell>3 micro influencer</TableCell>
                    <TableCell>Temel rapor + duygu analizi</TableCell>
                    <TableCell>%12 komisyon bakiyeden düşer</TableCell>
                    <TableCell>~440.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Büyüme Paketi</TableCell>
                    <TableCell>110.000 TL</TableCell>
                    <TableCell>1 Hafta Seaplay (8M erişim)</TableCell>
                    <TableCell>14 gün ana sayfa + kategori</TableCell>
                    <TableCell>7 nano/micro influencer</TableCell>
                    <TableCell>Gelişmiş funnel raporu</TableCell>
                    <TableCell>%12 komisyon bakiyeden düşer</TableCell>
                    <TableCell>~1.100.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Premium Paket</TableCell>
                    <TableCell>187.000 TL</TableCell>
                    <TableCell>1 Hafta YoviSt + ATM</TableCell>
                    <TableCell>30 gün hero + kategori dominasyonu</TableCell>
                    <TableCell>20 influencer</TableCell>
                    <TableCell>İleri rapor + brand-lift</TableCell>
                    <TableCell>%12 komisyon bakiyeden düşer</TableCell>
                    <TableCell>~1.870.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Custom</TableCell>
                    <TableCell>Esnek</TableCell>
                    <TableCell>Kombinasyon</TableCell>
                    <TableCell>Özel</TableCell>
                    <TableCell>Özel</TableCell>
                    <TableCell>Özel raporlama</TableCell>
                    <TableCell>%12 komisyon bakiyeden düşer</TableCell>
                    <TableCell>Belirlenecek</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );

    const PaketsTableLocal = (
        <Table size="small" sx={{ mt: 1 }}>
            <TableHead>
                <TableRow>
                    <TableCell>Paket</TableCell>
                    <TableCell>Bakiye</TableCell>
                    <TableCell>Hediye Medya</TableCell>
                    <TableCell>Uygulama İçi</TableCell>
                    <TableCell>Reklam Desteği</TableCell>
                    <TableCell>Komisyon</TableCell>
                    <TableCell>GMV Tavanı</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell>Komisyon Bazlı</TableCell>
                    <TableCell>–</TableCell>
                    <TableCell>100 alt reklam</TableCell>
                    <TableCell>Sınırsız kampanya</TableCell>
                    <TableCell>–</TableCell>
                    <TableCell>%12 satış komisyonu</TableCell>
                    <TableCell>Sınırsız</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Büyüme Paketi</TableCell>
                    <TableCell>50.000 TL</TableCell>
                    <TableCell>1 Hafta Yovi Metro (12M erişim)</TableCell>
                    <TableCell>Gelişmiş rapor + 2 push</TableCell>
                    <TableCell>7.500 TL Meta (%15)</TableCell>
                    <TableCell>%12 komisyon bakiyeden düşer</TableCell>
                    <TableCell>~420.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Prestij Paketi</TableCell>
                    <TableCell>100.000 TL</TableCell>
                    <TableCell>1 Hafta Seaplay + 1 Hafta Yovi ATM</TableCell>
                    <TableCell>İleri rapor + 4 push</TableCell>
                    <TableCell>15.000 TL Meta (%15)</TableCell>
                    <TableCell>%12 komisyon bakiyeden düşer</TableCell>
                    <TableCell>~830.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Premium Paket</TableCell>
                    <TableCell>187.000 TL</TableCell>
                    <TableCell>1 Hafta YoviSt Full + 1 Hafta Yovi ATM</TableCell>
                    <TableCell>Brand-lift + 8 push + e-posta</TableCell>
                    <TableCell>28.000 TL Meta (%15)</TableCell>
                    <TableCell>%12 komisyon bakiyeden düşer</TableCell>
                    <TableCell>~1.560.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Custom</TableCell>
                    <TableCell>Esnek</TableCell>
                    <TableCell>Kombinasyon</TableCell>
                    <TableCell>Özel rapor</TableCell>
                    <TableCell>Bütçenin %15’i Meta</TableCell>
                    <TableCell>%12 komisyon bakiyeden düşer</TableCell>
                    <TableCell>Belirlenecek</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            scroll="paper"
            PaperProps={{ sx: { borderRadius: 4, p: 0.5 } }}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center", pr: 6 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h5" fontWeight={800}>Alcago Hizmet ve Bakiye Kullanım Sözleşmesi</Typography>
                    <Chip size="small" label={new Date().toLocaleDateString("tr-TR")} />
                </Stack>
                <IconButton aria-label="Kapat" onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {/* Taraflar */}
                <Section title="Taraflar" id="taraflar">
                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Alcago</Typography>
                    <Box sx={{ mb: 2 }}>
                        <InfoRow label="Unvan" value='Alcago Teknoloji Anonim Şirketi (" Alcago")' />
                        <InfoRow label="MERSİS" value="0050117816000001" />
                        <InfoRow label="Adres" value="İdealtepe Mah. Denizciler Cad. No: 22 İç Kapı No: 4, Maltepe / İstanbul" />
                        <InfoRow label="E-posta" value="destek@alcago.com" />
                        <InfoRow label="Telefon" value="0539 397 13 63" />
                    </Box>

                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Marka</Typography>
                    <Box>
                        <InfoRow label="Unvan" value={`${markaUnvan} ("Marka")`} />
                        <InfoRow label="MERSİS/Vergi No" value={markaMersisVno} />
                        <InfoRow label="Adres" value={markaAdres} />
                        <InfoRow label="Temsilci" value={markaTemsilciAdSoyad} />
                        <InfoRow label="E-posta" value={markaEposta} />
                        <InfoRow label="Telefon" value={markaTel} />
                    </Box>
                    <Typography variant="body2" sx={{ mt: 1 }} color="text.secondary">
                        Nitelik: İşbu sözleşme tacir sıfatıyla hareket eden taraflar arasında akdedilmiştir; tüketici mevzuatına tabi değildir.
                    </Typography>
                </Section>

                {/* Bölümler */}
                <Section title="1. Tanımlar" id="tanimlar">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li><strong>Panel:</strong> Markaların paket/bakiye satın aldığı, kampanya oluşturduğu ve raporları görüntülediği arayüz.</li>
                        <li><strong>Bakiye:</strong> Sadece Alcago hizmetlerinde geçerli hizmet kredisi; iade edilemez, finansal varlık değildir.</li>
                        <li><strong>Komisyon:</strong> Marka satışları üzerinden %12.</li>
                        <li><strong>Paket:</strong> EK-1 ve EK-2’deki hizmet kombinasyonları.</li>
                        <li><strong>Hediye Medya:</strong> Paketle ücretsiz tahsis edilen görünürlük/reklam hakları.</li>
                        <li><strong>Doğrudan Ödeme Modeli:</strong> Ödemenin Alcago üzerinden yapıldığı akış.</li>
                    </ul>
                </Section>

                <Section title="2. Konu" id="konu">
                    <Typography>Markanın panel üzerinden bakiye/paket satın alması, komisyon bazlı çalışma veya doğrudan ödeme modeline ilişkin hükümler.</Typography>
                </Section>

                <Section title="3. Modeller" id="modeller">
                    <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 1 }}>3.1 Komisyon Bazlı Model</Typography>
                    <ul style={{ marginTop: 4, paddingLeft: 18 }}>
                        <li>Ön ödeme yok.</li>
                        <li>Kullanıcıların {markaUnvan || "[Marka]"} e-ticaret sitesindeki her satış için %12 komisyon.</li>
                        <li>Komisyon ay sonunda raporlanır, 15 gün içinde faturalanır.</li>
                        <li>İptal/iade edilen satışlardan komisyon doğmaz.</li>
                    </ul>

                    <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>3.2 Bakiye Yüklemeli Model (Paket Satışı)</Typography>
                    <ul style={{ marginTop: 4, paddingLeft: 18 }}>
                        <li>Marka, {paketAdi || "[Paket Adı]"} kapsamında {bakiyeTutari || "[Tutar]"} TL bakiye yükler.</li>
                        <li>Bakiye iade edilmez; yalnızca hizmet kredisi.</li>
                        <li>%12 komisyon, yüklenen bakiyeden mahsup edilir.</li>
                        <li>GMV tavanları ve detaylar EK-1’dedir.</li>
                        <li>Hediye Medya tahsisi en iyi çaba esasıyla yapılır.</li>
                    </ul>

                    <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>3.3 Doğrudan Ödeme Modeli (Fırsat/Lokal)</Typography>
                    <ul style={{ marginTop: 4, paddingLeft: 18 }}>
                        <li>Kullanıcı, {urunHizmetAdi || "[Ürün/Hizmet]"} için {kullaniciOdemeTutari || "[Ödeme]"} TL öder.</li>
                        <li>14 günlük cayma sonrası, %12 + KDV kesilerek kalan tutar {markaIban || "[IBAN]"}’a aktarılır.</li>
                        <li>İade edilen işlemler için aktarım yapılmaz; komisyon doğmaz.</li>
                        <li>Komisyon için Alcago kendi adına fatura düzenler; kalan tutar Markanın faturasına istinaden ödenir.</li>
                    </ul>
                </Section>

                <Section title="4. Ödeme ve Faturalandırma">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Tüm tahsilatlar Sipay üzerinden yapılır; Alcago ödeme hizmeti sunmaz.</li>
                        <li>Faturalar e-fatura/e-arşivdir.</li>
                        <li>Temerrütte aylık %2 faiz.</li>
                        <li>Ödül/puan/hediyelerden doğan vergi yükümlülükleri Markaya aittir.</li>
                    </ul>
                </Section>

                <Section title="5. Marka’nın Yükümlülükleri">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>İndirim kodlarının geçerliliği, stok doğruluğu ve kampanya koşullarından sorumludur.</li>
                        <li>Ürün/hizmet ayıbı, teslim, iade ve tüketici uyuşmazlıklarından tamamen Marka sorumludur.</li>
                        <li>Yüklenen görsel/logo/içeriklerin üçüncü kişi haklarını ihlal etmeyeceğini garanti eder.</li>
                        <li>Vaat edilen indirim ve promosyonların doğruluğunu sağlar.</li>
                    </ul>
                </Section>

                <Section title="6. Alcago’nun Yükümlülükleri">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Paket kapsamındaki hizmetleri zamanında sunmak.</li>
                        <li>Panel raporlarını sağlamak.</li>
                        <li>Verileri anonim/istatistiksel şekilde raporlamak.</li>
                    </ul>
                </Section>

                <Section title="7. Sorumluluğun Sınırlandırılması">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Alcago, Markanın içerik ve ürün/hizmetinden sorumlu değildir.</li>
                        <li>Toplam sorumluluk ilgili paket için ödenen toplam bedelle sınırlıdır.</li>
                        <li>Dolaylı zarar/kar kaybı/itibar zedelenmesinden sorumlu değildir.</li>
                    </ul>
                </Section>

                <Section title="8. Tazminat">
                    <Typography>Marka; içerik, stok, indirim kodu geçerliliği ve tüketici uyuşmazlıklarından doğabilecek tüm taleplerde Alcago’yu sorumlu tutmayacağını ve doğacak zarar/ceza/masrafları tazmin edeceğini kabul eder.</Typography>
                </Section>

                <Section title="9. KVKK ve Veri">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Kullanıcı verileri KVKK’ya uygun işlenir.</li>
                        <li>Marka’ya yalnız anonim/istatistiksel raporlar aktarılır.</li>
                        <li>Gerektiğinde Veri İşleme Protokolü (EK-3) yürürlüğe girer.</li>
                    </ul>
                </Section>

                <Section title="10. İçerik Standartları">
                    <Typography>Yasadışı bahis, alkol, tütün, müstehcenlik, yanıltıcı sağlık beyanı vb. içerikler yasaktır; Alcago bu içerikleri gerekçesiz reddedebilir.</Typography>
                </Section>

                <Section title="11. Fikri Mülkiyet">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Marka, içerikler üzerinde Alcago’ya kullanım lisansı verir.</li>
                        <li>Alcago yazılım, tasarım ve veri tabanı haklarının sahibidir.</li>
                    </ul>
                </Section>

                <Section title="12. Mücbir Sebep" />
                <Section title="13. Süre ve Fesih">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Elektronik onay ile yürürlüğe girer.</li>
                        <li>Taraflar 30 gün önceden bildirimle feshedebilir.</li>
                        <li>Fesih halinde kullanılmayan bakiyeler iade edilmez.</li>
                    </ul>
                </Section>

                <Section title="14. Alt Yüklenici ve Ödeme Kuruluşları">
                    <Typography>Alcago; Sipay, App Prize ve affiliate ağları gibi alt yüklenicilerle çalışabilir. Marka bu hususu kabul eder.</Typography>
                </Section>

                <Section title="15. Bildirimler ve Elektronik Delil">
                    <Typography>Bildirimler e-posta veya panel üzerinden yapılır. Panel logları ve işlem kayıtları kesin delildir.</Typography>
                </Section>

                <Section title="16. Hukuk ve Yetki">
                    <Typography>Türk hukuku uygulanır. İstanbul Merkez (Çağlayan) Mahkemeleri ve İcra Daireleri yetkilidir.</Typography>
                </Section>

                <Section title="17. Elektronik Kabul">
                    <Typography>Marka, sözleşmeyi elektronik ortamda onayladığında tüm hükümleri kabul etmiş olur.</Typography>
                </Section>

                {/* EKLER */}
                <Section title="EK-1: Perakende Paketleri ve İçerikleri">{PaketsTableRetail}</Section>
                <Section title="EK-2: Fırsat / Lokal Paketleri ve İçerikleri">{PaketsTableLocal}</Section>

                <Section title="EK-3: Veri İşleme Protokolü (DPA)">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li><strong>Taraflar:</strong> Alcago (veri sorumlusu/işleyen), {markaUnvan || "[Marka]"} (veri sorumlusu)</li>
                        <li><strong>Veriler:</strong> Kimlik, iletişim, işlem/etkileşim, cihaz, rezervasyon</li>
                        <li><strong>Amaç:</strong> Kampanya yürütme, raporlama, satış atfı</li>
                        <li><strong>Güvenlik:</strong> Şifreleme, erişim kontrolü, loglama</li>
                        <li><strong>Alt İşleyenler:</strong> Sipay, App Prize, affiliate ağları</li>
                        <li><strong>Yurt Dışı Aktarım:</strong> Açık rıza ile</li>
                        <li><strong>İhlal Bildirimi:</strong> 72 saat içinde</li>
                    </ul>
                </Section>

                <Section title="EK-4: Marka Kullanım ve Kreatif Rehber">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Marka, logosu/görsellerinin kampanya süresince kullanımına izin verir.</li>
                        <li>Alcago içerikleri değiştirmez; interaktif katman uygular.</li>
                        <li>RTÜK ve Reklam Kurulu mevzuatına aykırı içerikler yasaktır.</li>
                    </ul>
                </Section>

                <Section title="EK-5: Tebligat Bilgileri">
                    <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 1 }}>Alcago</Typography>
                    <InfoRow label="Adres" value="İdealtepe Mah. Denizciler Cad. No: 22 İç Kapı No: 4, Maltepe / İstanbul" />
                    <InfoRow label="E-posta" value="destek@alcago.com" />
                    <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 2 }}>Marka</Typography>
                    <InfoRow label="Adres" value={markaAdres} />
                    <InfoRow label="E-posta" value={markaEposta} />
                </Section>

                <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                    <Button variant="outlined" onClick={onClose}>Kapat</Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
